/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24 0C12.696 0 3.522 9.174 3.522 20.478 3.522 40.136 24 48 24 48s20.478-7.864 20.478-27.522C44.478 9.174 35.304 0 24 0zm-.164 31.945c-6.389 0-11.631-5.242-11.631-11.631S17.447 8.683 23.836 8.683s11.632 5.242 11.632 11.631-5.079 11.631-11.632 11.631z" fill-rule="nonzero"/>'
}
